import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import BuyLicenses from "./components/buy-licenses";
import './index.css';

class BuyOrUpgrade extends Component {
    constructor(props){
        super(props)
        this.state = {
           isHover: false
        }
    }

    onMouseEnter = () => {
        this.setState({isHover:true})

    };

    onMouseLeave = () => {
        this.setState({isHover:false})
    };

    render (){

        const dataLayerFunc = () => {
            if(window.dataLayer) {
                window.dataLayer.push({
                    'buyClicked': 'true',
                    event: 'buyClicked'
                });
            }
        };

        if(this.props.profile !== null){
            if(this.props.profile.domain !== null){

                return (
                    <div className="d-flex align-items-center buy-upgrade ml-4">
                        {
                            (
                                this.props.profile.domain.status === "FREE"
                                || this.props.profile.domain.status === "EXPIRED_PAID"
                                || this.props.profile.domain.status === "INVITED_EVAL"
                                || this.props.profile.domain.status === "INVITED_EXPIRED_EVAL"
                                || this.props.profile.domain.status === "INVITED_EXPIRED_PAID"
                                || this.props.profile.domain.status === "INVITED_PAID"
                                || this.props.profile.domain.status === "INVITED_UNINSTALLED_EVAL"
                                || this.props.profile.domain.status === "INVITED_UNINSTALLED_PAID"
                                || this.props.profile.domain.plan === "INVITED"
                            )
                            ?
                                <a className="btn-buy text-nowrap" href={`/api/payment/new`} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={dataLayerFunc} target="_blank" rel="noreferrer">
                                    {this.state.isHover && <div className="buy-upgrade__tooltip">{this.props.t("textBuy")}</div>}
                                    <svg version="1.1" baseProfile="tiny"
                                         xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 56 48"
                                         xmlSpace="preserve">
                                        <g>
                                            <g>
                                                <path fill="currentColor" d="M40.6,39.4H15.4C6.9,39.4,0,32.5,0,24S6.9,8.6,15.4,8.6h25.1C49.1,8.6,56,15.5,56,24S49.1,39.4,40.6,39.4z
                                                     M15.4,10.1C7.8,10.1,1.6,16.4,1.6,24s6.2,13.9,13.9,13.9h25.1c7.6,0,13.9-6.2,13.9-13.9s-6.2-13.9-13.9-13.9H15.4z"/>
                                            </g>
                                            <g>
                                                <path fill="currentColor" d="M30.9,20.2h3c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.4,0.4,0.5,0.6
                                                    c0.1,0.2,0.2,0.5,0.2,0.7c0,0.4-0.1,0.8-0.3,1c-0.2,0.3-0.4,0.5-0.7,0.6v0.1c0.4,0.1,0.7,0.4,0.9,0.7c0.2,0.3,0.3,0.7,0.3,1.1
                                                    c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-1,0.1h-3.1V20.2z M33.8,23.2
                                                    c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.2-0.3,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.1-0.4-0.2-0.6-0.2h-1.3v1.5H33.8z M33.9,26.3
                                                    c0.7,0,1-0.3,1-0.8s-0.4-0.8-1.1-0.8h-1.4v1.7H33.9z"/>
                                                <path fill="currentColor" d="M40.5,27.9c-0.5,0-0.9-0.1-1.2-0.2c-0.4-0.1-0.7-0.4-0.9-0.6c-0.3-0.3-0.5-0.6-0.6-1
                                                    c-0.1-0.4-0.2-0.9-0.2-1.4v-4.4h1.6v4.5c0,0.5,0.1,0.8,0.3,1.1c0.2,0.3,0.6,0.4,1,0.4s0.8-0.2,1-0.4c0.2-0.3,0.3-0.7,0.3-1.1v-4.5
                                                    h1.6v4.4c0,0.5-0.1,0.9-0.2,1.3c-0.1,0.4-0.3,0.7-0.6,1c-0.3,0.3-0.6,0.5-0.9,0.7C41.4,27.8,41,27.9,40.5,27.9z"/>
                                                <path fill="currentColor" d="M46.7,24.2l-2.5-4h2l1.3,2.2h0.1l1.3-2.2h2l-2.5,4v3.5h-1.6V24.2z"/>
                                            </g>
                                            <g>
                                                <path fill="currentColor" d="M12.8,28.7c-1.2,0-2.1,1-2.1,2.1c0,1.2,1,2.1,2.1,2.1s2.1-1,2.1-2.1C14.9,29.6,14,28.7,12.8,28.7z
                                                     M13.6,30.8c0,0.4-0.3,0.8-0.8,0.8S12,31.2,12,30.8c0-0.4,0.3-0.8,0.8-0.8S13.6,30.4,13.6,30.8z"/>
                                                <path fill="currentColor" d="M21.7,28.7c-1.2,0-2.1,1-2.1,2.1c0,1.2,1,2.1,2.1,2.1c1.2,0,2.1-1,2.1-2.1C23.8,29.6,22.8,28.7,21.7,28.7z
                                                     M22.4,30.8c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8S22.4,30.4,22.4,30.8z"/>
                                                <path fill="currentColor" d="M26,17.9c-0.1-0.1-0.3-0.2-0.5-0.3l-14.3-0.2l-0.3-1c-0.3-0.9-1.1-1.4-2-1.5H7.5c-0.4,0-0.7,0.3-0.7,0.7
                                                    c0,0.4,0.3,0.7,0.7,0.7h1.4c0.3,0,0.6,0.2,0.8,0.5l2.6,7.8L12,25.2c-0.3,0.7-0.2,1.4,0.2,2c0.4,0.6,1,1,1.8,1h9.1
                                                    c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7H14c-0.3,0-0.5-0.1-0.7-0.4c-0.1-0.2-0.2-0.5-0.1-0.7l0.1-0.2l9.6-0.9
                                                    c1.1-0.1,1.9-0.9,2.2-1.9l1-4.1C26.2,18.3,26.2,18.1,26,17.9z M13.4,24.1l-1.7-5.3l13,0.2l-0.8,3.3c-0.1,0.5-0.5,0.9-1,0.9
                                                    L13.4,24.1z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </a>
                            :
                                ''
                        }
	                    {
		                    (
		                        this.props.profile.domain.status === "PAID"
                                || this.props.profile.domain.status === "UNINSTALLED_PAID"
                            )
			                    ?
			                    <a className="btn-upgrade text-nowrap" href={`/api/payment/upgrade`} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} target="_blank" rel="noreferrer">
				                    {this.state.isHover && <div className="buy-upgrade__tooltip">{this.props.t("tooltipUpgrade")}</div>}
				                    <svg version="1.1" baseProfile="tiny"
				                         x="0px" y="0px" viewBox="0 0 48 48"
				                         xmlSpace="preserve">
					                    <circle fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeMiterlimit="10" cx="24" cy="24" r="14"/>
					                    <g>
						                    <line fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeMiterlimit="10" x1="24" y1="15.3" x2="24" y2="32.8"/>
						                    <polyline fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeMiterlimit="10" points="16.6,22.7
                                            24,15.3 31.4,22.7"/>
					                    </g>
				                    </svg>
			                    </a>
			                    :
			                    ''
	                    }
                        {
                            this.props.profile.domain.plan !== "BASIC"
                            && (
                                this.props.profile.domain.status === "PAID"
                                || this.props.profile.domain.status === "UNINSTALLED_PAID"
                            ) && <BuyLicenses/>
                        }
                        {/*
                        this.props.profile.domain.status === "FREE" || this.props.profile.domain.plan === "INVITED"
                        ?
                            <a className="py-2 px-3 cta mr-4 text-nowrap" href={`/account/try`}><FormattedMessage id="global.try" default="try"/></a>
                        :
                            ''
                        */}
                        {/*
                        this.props.profile.domain.status === "PAID"
                        ?
                            this.props.profile.domain.plan === "LITE" || this.props.profile.domain.plan === "TEAM"
                            ?
                                <p className="mt-1 mb-0"><a href={"/payment/upgrade"} target="_blank">Pricing</a></p>
                            :
                                ''
                        :
                            <p className="mt-1 mb-0"><a href={"/payment/new"} target="_blank">Pricing</a></p>
                    */}
                    </div>
                )

            } else {
                return null
            }
        } else {
            return null
        }
    }
}

const mapStateToProps = (state) => {
    return {
        profile : state.profileReducer.getProfile
    };
};

export default connect(mapStateToProps)(withTranslation()(BuyOrUpgrade));
